// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
import fn from "../../formatRelative/index.js";
import convertToFP from "../_lib/convertToFP/index.js";
export default convertToFP(fn, 2);